const Skeleton = ({ className }) => {
  return <div className={`${className} animate-pulse bg-gray-100 `} />;
};

export default Skeleton;
